import { Avatar } from "@mui/material";
import type { AvatarProps } from "@mui/material";

export interface TopbarProfileProps extends AvatarProps {
    initials: string;
}

// `MuiAvatar` is already themed globally (navy-tinted initials chip), so this
// stays a thin wrapper that just defaults the children to `initials`.
export const TopbarProfile = ({ initials, children, src, ...rest }: TopbarProfileProps) => {
    return (
        <Avatar src={src} {...rest}>
            {src ? undefined : (children ?? initials)}
        </Avatar>
    );
};
